
import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';

const Startpage = (props) => {
  const { loggedIn, email } = props
  const navigate = useNavigate()
  const t = props.translation

  const navigatetopwr = () => {
    navigate("/passReset")
  }

  const onButtonClick = () => {
    navigate("/login");
  }


  if (loggedIn) {

    navigate("/")

  }

  return (
    <div className="mainContainer">
      <div className={'titleContainer'}>
        {/* <div>SAM</div> */}
        <img
          src="/img/logo.svg"
          alt="SAM logo"
          className='logowelcome'
        />
      </div>
      {/* <div>Welcome to SAM</div> */}
      <div className={'buttonContainer'}>
        <input
          className='inputButton'
          type="button"
          onClick={() => onButtonClick()}
          // t("logout"):t("login")}
          value={loggedIn ? t("logout") : t("login")}
        />
        <Button onClick={navigatetopwr}>{t("resetPWD")}</Button>
      </div>
    </div>
  )
}
export default Startpage;